import parse from 'date-fns/parse';
import format from 'date-fns/format';

export const getDateFormat = (dateString: string) => {
	const dateObject = parse(dateString, 'yyyy-MM-dd', Date.now());
	return format(dateObject, 'dd/MM/yyyy');
};
